import { Paper } from '@mui/material';
import axios from 'axios';
import TopBar from 'components/Layout/TopBar';
import { logError } from 'components/Utils/FormatData';
import { URL_API } from 'utils/globalConfig';
import useAuthz from 'hooks/useAuthz';
import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router';
import { ClipLoader } from 'react-spinners';
import moment from 'moment/moment';
import AgGrid from '../../components/AgGrid/AgGrid';
import MyButton from '../../components/Layout/MyButton';

const Tracings = (props) => {
    const alert = useAlert();
    const navigate = useNavigate();
    const [authz, user, profil] = useAuthz();
    const [tracings, setTracings] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const columns = [
        {
            headerName: 'n°',
            field: 'id',
            flex: 1,
            minWidth: 150,
            sortable: true,
            resizable: true,
            filter: 'agNumberColumnFilter',
        },
        {
            headerName: 'login',
            field: 'account.login',
            flex: 2,
            minWidth: 150,
            sortable: true,
            resizable: true,
            valueFormatter: (params) => (params.data.account ? params.data.account.login : '-'),
            filter: 'agTextColumnFilter',
        },
        {
            headerName: 'Date',
            field: 'date_tracing',
            flex: 2,
            minWidth: 150,
            sortable: true,
            resizable: true,
            valueFormatter: (params) => (params.data.date_tracing ? `Le ${moment(params.data.date_tracing).format('DD/MM/YYYY à HH:mm')}` : '-'),
            filter: 'agDateColumnFilter',
        },
        {
            headerName: 'description',
            field: 'description',
            flex: 6,
            minWidth: 150,
            sortable: true,
            resizable: true,
            valueFormatter: (params) => (params.data.description ? params.data.description : '-'),
            cellStyle: { 'justify-content': 'flex-start' },
            filter: 'agTextColumnFilter',
        },
    ];
    const [agGridOptions, setAgGridOptions] = useState({
        suppressCellSelection: true,
        suppressHorizontalScroll: false,
        animateRows: true,
    });

    useEffect(() => {
        if (profil.profil !== 1) {
            alert.error('Vous n\'êtes pas autorisé à accéder au module [Historique des actions]');
            navigate('/');
        } else {
            document.title = 'TE - Historique des actions';
            if (!tracings) {
                getTracings();
            }
        }
    }, []);

    const getTracings = () => {
        setIsLoading(true);
        axios({ method: 'get', url: URL_API + '/tracing/liste' })
        .then((response) => {
            setIsLoading(false);
            setTracings(response.data);
        })
        .catch((error) => {
            setIsLoading(false);
            logError(alert, error);
        });
    };

    return (
        <div style={{ height: '100%' }}>
            <TopBar title='Historique des actions' className='topbar-contenu' color={props.params.color}
                    buttons={
                        <div className='topbar-buttons'>
                            <MyButton onClick={() => navigate('/panneau-administration')} icon={''} label={'Retour'} />
                        </div>
                    }
            />

            <div className='row' style={{ margin: 0 }}>
                <ClipLoader color='#0094ca' loading={isLoading} size={75}
                            css={'display: flex; margin: 25px;justify-content: center;'} />

                {!isLoading && tracings && (
                    <Paper style={{ width: '100%', borderTop: '1px solid #4db4da' }}>
                        <AgGrid
                            key={'ag-grid-tracings'}
                            rowData={tracings}
                            columnDefs={columns}
                            rowHeight={40}
                            pagination={true}
                            paginationPageSize={25}
                            frameworkComponents={null}
                            gridOptions={agGridOptions}
                            setGridOptions={setAgGridOptions}
                            sortable={false}
                            gridName='ag-grid-actions'
                        />
                    </Paper>
                )}
            </div>
        </div>
    );
};

export default Tracings;
